import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { CloneQuestionUseCaseInterface } from 'domain/usecases';

export class RemoteCloneQuestion implements CloneQuestionUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: CloneQuestionUseCaseInterface.Params,
  ): Promise<CloneQuestionUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/clone`,
      body: params,
      method: 'post',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
